import {SignalRHub, SignalREvent, ViewMode} from '../../constants/dataEnum';
import {setPendingSaveExistStatus} from '../actions/protocolEditorAction';
// eslint-disable-next-line import/no-cycle
import {invokeAPI, silentInvokeAPI} from './commonBusiness';

export const saveState =
  (setPendingSave = true) =>
  (dispatch, getState) => {
    const state = getState();

    const {
      appState,
      cardState,
      reportState,
      labwareState,
      plateTypeEditorState,
      protocolState,
      runtimeState,
      sessionState,
      tipState,
      trayCalibrationState,
      temporaryState,
      normalizationState,
      protocolEditorState,
      undoRedoState,
      wizardState,
      reteachPlateState,
      plateRecognitionState,
    } = state;

    const stateJson = {
      appState,
      cardState,
      reportState,
      labwareState,
      plateTypeEditorState,
      protocolState,
      runtimeState,
      sessionState,
      tipState,
      trayCalibrationState,
      temporaryState,
      normalizationState,
      protocolEditorState,
      undoRedoState,
      wizardState,
      reteachPlateState,
      plateRecognitionState,
    };

    const ignoredPropsList = ['deckLabwareRefs'];

    const replacer = (key, value) => {
      // if (value instanceof HTMLElement) return '[HTMLELEMENT]';
      if (ignoredPropsList.includes(key)) return '[IGNORED]';

      return value;
    };

    const jsonBody = JSON.stringify(stateJson, replacer);
    const {userId} = sessionState.user;
    const {viewMode} = appState;

    if (!protocolEditorState.autosave && viewMode === ViewMode.PROTOCOL_EDITOR && setPendingSave) {
      dispatch(setPendingSaveExistStatus(true));
    }

    dispatch(silentInvokeAPI(SignalRHub.SESSION, SignalREvent.UPDATE_SESSION, userId, jsonBody));
  };

export const setFastInfo = (fastInfo) => async (dispatch) => {
  console.log('setFastInfo start');

  const response = await dispatch(invokeAPI(SignalRHub.STATE, SignalREvent.SET_FAST_INFO, fastInfo));

  console.log('setFastInfo end, response:', response);

  return response;
};

export const getLastFastInfo = () => async (dispatch) => {
  const response = await dispatch(invokeAPI(SignalRHub.STATE, SignalREvent.GET_LAST_FAST_INFO));

  console.log('getLastFastInfo', response);

  return response;
};

export const setLicenseData = (licenseData) => async (dispatch) => {
  console.log('setLicenseData start');

  const response = await dispatch(invokeAPI(SignalRHub.STATE, SignalREvent.SET_LICENSE_DATA, licenseData));

  console.log('setLicenseData end, response:', response);

  return response;
};

export const getLastLicenseData = () => async (dispatch) => {
  const response = await dispatch(invokeAPI(SignalRHub.STATE, SignalREvent.GET_LAST_LICENSE_DATA));

  console.log('getLastLicenseData', response);

  return response;
};

export const isProtocolExecutor = (returnPayload) => async (dispatch, getState) => {
  const {code: runningProtocolResponseCode, payload: runningProtocolResponsePayload} = await dispatch(
    invokeAPI(SignalRHub.STATE, SignalREvent.GET_RUNNING_PROTOCOL),
  );
  let executor = false;
  const {sessionState} = getState();
  let payload = null;

  if (runningProtocolResponseCode === 0) {
    const loggedInUserId = sessionState.user.userId;
    let protocolExecutorUserId = null;
    protocolExecutorUserId = runningProtocolResponsePayload?.user?.userId;
    payload = runningProtocolResponsePayload;

    executor = protocolExecutorUserId === loggedInUserId;
  }

  if (returnPayload) return {isExecutor: executor, payload};

  return executor;
};
